module.exports = __webpack_public_path__ + "img/appAsset--documents-ax.9d2cd7b5.svg";